import { css } from 'styled-components';
import { PURPLE_LIGHT } from '../../../constants/colors';
import { rem } from '../../../helpers/mixins';

export default {
  wrapper: css`
    margin-bottom: 8px;
  `,
  inputWrapper: ({ backgroundColor }) => css`
    display: flex;
    flex: 1;
    line-height: ${rem('14px')};
    background-color: ${backgroundColor};
    padding: 10px;
  `,
  label: ({ color }) => css`
    color: ${color || PURPLE_LIGHT};
    font-size: ${rem('12px')};
    margin-left: 8px;
  `,
  input: css`
    display: flex;
    flex-shrink: 0;
  `
};
